import styled from 'styled-components';
import Title from 'desktop/components/Title';
import Text from 'desktop/components/Text';
import { mediaTemplates } from 'desktop/theme/variables';


export const DateStyled = styled.div.attrs({
  style: (props) => ({
    transform: `translateY(${props.offsetTop}px)`,
  }),
})`
  position: absolute;
  left: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  will-change: transform;

  ${mediaTemplates.s} {
    flex-direction: row;
    align-items: center;
    left: -20px;
    height: 75px;
    background-color: rgba(0, 0, 0, 0.5);
    padding-left: 35px;
    width: calc(100% + 20px);
  }
`;

export const StyledText = styled(Text)`
  && {
    text-transform: lowercase;
    line-height: 1.25;
    font-size: 15px;

    ${mediaTemplates.s} {
      font-size: 24px;
      margin-right: 5px;
    }
    ${mediaTemplates.l} {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const StyledTitle = styled(Title)`
  && {
    text-transform: lowercase;
    font-size: 60px;
    line-height: 0.95;

    ${mediaTemplates.s} {
      font-size: 24px;
      margin-right: 5px;
    }
    ${mediaTemplates.l} {
      font-size: 90px;
    }
  }
`;
